import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock(_Transition, {
        name: _ctx.name,
        onBeforeAppear: _ctx.beforeAppear,
        onAppear: _ctx.appear,
        onAfterAppear: _ctx.afterAppear,
        onAppearCancelled: _ctx.appearCancelled,
        onBeforeEnter: _ctx.beforeEnter,
        onEnter: _ctx.enter,
        onAfterEnter: _ctx.afterEnter,
        onEnterCancelled: _ctx.enterCancelled,
        onBeforeLeave: _ctx.beforeLeave,
        onLeave: _ctx.leave,
        onAfterLeave: _ctx.afterLeave,
        onLeaveCancelled: _ctx.leaveCancelled
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
    }, 8, ["name", "onBeforeAppear", "onAppear", "onAfterAppear", "onAppearCancelled", "onBeforeEnter", "onEnter", "onAfterEnter", "onEnterCancelled", "onBeforeLeave", "onLeave", "onAfterLeave", "onLeaveCancelled"]));
}
